/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { GTMRegisterBeginPayload } from '@/data/types/GTM';

export const getGTMRegisterBeginEventData = (payload: GTMRegisterBeginPayload) => ({
	login_step: 1,
	login_origin: payload.login_origin,
});
